import React, { useState } from 'react';

const ImageUploadField = React.forwardRef<
  HTMLInputElement,
  {
    defaultSrc: string;
    [x: string]: any;
  }
>(({ defaultSrc, ...props }, ref) => {
  const [previewSrc, setPreviewSrc] = useState<string>('');

  return (
    <div className="col-span-2 flex flex-col items-center space-y-2">
      <div
        className="rounded-full overflow-hidden h-12 w-12"
        aria-hidden="true"
      >
        {!previewSrc && !defaultSrc && (
          <svg
            className="h-full w-full rounded-full text-gray-300"
            fill="currentColor"
            viewBox="0 0 24 24"
          >
            <path d="M24 20.993V24H0v-2.996A14.977 14.977 0 0112.004 15c4.904 0 9.26 2.354 11.996 5.993zM16.002 8.999a4 4 0 11-8 0 4 4 0 018 0z" />
          </svg>
        )}
        {previewSrc && (
          <img
            className="relative rounded-full w-full h-full object-cover"
            src={previewSrc}
            alt=""
          ></img>
        )}
        {defaultSrc && !previewSrc && (
          <img
            className="relative rounded-full w-full h-full object-cover"
            src={defaultSrc}
            alt=""
          ></img>
        )}
      </div>
      <div className="rounded-md shadow-sm">
        <div className="group relative border border-gray-300 rounded-md py-2 px-3 flex items-center justify-center hover:bg-gray-50 focus-within:ring-2 focus-within:ring-offset-2 focus-within:ring-light-blue-500">
          <label
            htmlFor="avatar"
            className="relative text-sm leading-4 font-medium text-gray-700 pointer-events-none"
          >
            <span>Change</span>
            <span className="sr-only">image</span>
          </label>
          <input
            id="avatar"
            {...props}
            ref={ref}
            type="file"
            onChange={(e: React.ChangeEvent<HTMLInputElement>) => {
              setPreviewSrc(URL.createObjectURL(e.target.files![0]));
            }}
            className="absolute w-full h-full opacity-0 cursor-pointer border-gray-300 rounded-md"
          />
        </div>
      </div>
    </div>
  );
});

export default ImageUploadField;
